<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <expandable-text :text="subheading" :maxLength="100" />
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faStar, faPlus } from "@fortawesome/free-solid-svg-icons";
import ExpandableText from "./ExpandableText.vue";

library.add(faStar, faPlus);

export default {
  props: {
    icon: String,
    heading: String,
    subheading: String,
  },
  components: {
    ExpandableText,
  },
};
</script>
